/**
 * 按柜型分色：画布上的框、客户版/工厂版导出的图纸页共用这一套，
 * 保证"图上什么颜色 = 什么柜型"在屏幕和纸上一致。
 */
export type BoxColor = {
  /** 边框颜色 */
  stroke: string;
  /** 填充（半透明） */
  fill: string;
  /** 编号标签底色 */
  label: string;
  /** 中文名（图例用） */
  labelZh: string;
  /** 英文名（图例用） */
  labelEn: string;
};

export const CABINET_TYPE_COLORS: Record<string, BoxColor> = {
  base: {
    stroke: "#2563eb",
    fill: "rgba(37,99,235,0.12)",
    label: "#2563eb",
    labelZh: "地柜",
    labelEn: "Base",
  },
  wall: {
    stroke: "#7c3aed",
    fill: "rgba(124,58,237,0.12)",
    label: "#7c3aed",
    labelZh: "吊柜",
    labelEn: "Wall",
  },
  tall: {
    stroke: "#0e7490",
    fill: "rgba(14,116,144,0.12)",
    label: "#0e7490",
    labelZh: "高柜",
    labelEn: "Tall",
  },
  island: {
    stroke: "#c2410c",
    fill: "rgba(194,65,12,0.12)",
    label: "#c2410c",
    labelZh: "岛台",
    labelEn: "Island",
  },
  display: {
    stroke: "#15803d",
    fill: "rgba(21,128,61,0.12)",
    label: "#15803d",
    labelZh: "展示柜",
    labelEn: "Display",
  },
  open_shelf: {
    stroke: "#4d7c0f",
    fill: "rgba(77,124,15,0.12)",
    label: "#4d7c0f",
    labelZh: "开放架",
    labelEn: "Open shelf",
  },
  wardrobe: {
    stroke: "#db2777",
    fill: "rgba(219,39,119,0.12)",
    label: "#db2777",
    labelZh: "衣柜",
    labelEn: "Wardrobe",
  },
  vanity: {
    stroke: "#0f766e",
    fill: "rgba(15,118,110,0.12)",
    label: "#0f766e",
    labelZh: "浴室柜",
    labelEn: "Vanity",
  },
  storage: {
    stroke: "#b45309",
    fill: "rgba(180,83,9,0.12)",
    label: "#b45309",
    labelZh: "储藏柜",
    labelEn: "Storage",
  },
  tv: {
    stroke: "#c026d3",
    fill: "rgba(192,38,211,0.12)",
    label: "#c026d3",
    labelZh: "电视柜",
    labelEn: "TV Cabinet",
  },
  custom: {
    stroke: "#64748b",
    fill: "rgba(100,116,139,0.12)",
    label: "#64748b",
    labelZh: "自定义",
    labelEn: "Custom",
  },
};

const FALLBACK: BoxColor = CABINET_TYPE_COLORS.custom!;

export function boxColorFor(cabinetType: string | undefined | null): BoxColor {
  return CABINET_TYPE_COLORS[cabinetType ?? ""] ?? FALLBACK;
}

/** 图上实际出现过的柜型（图例只列用到的） */
export function legendFor(cabinetTypes: string[]): BoxColor[] {
  const seen = new Set(cabinetTypes);
  return Object.keys(CABINET_TYPE_COLORS)
    .filter((code) => seen.has(code))
    .map((code) => CABINET_TYPE_COLORS[code]!);
}
